import ThemeProvider from 'contexts/Theme';
import { useContext } from 'react';

function useDark(): [boolean, (val: boolean) => void] {
  const { isDark, setIsDark } = useContext(ThemeProvider.Context);
  return [isDark, setIsDark];
}

export default useDark;
